var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatPathDemoNavigatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.987mm",
    height: "26.013mm",
    viewBox: "0 0 25.987 26.013",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.11 .26491)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    style: {
      display: "inline",
      fill: "#ffffff",
      stroke: "#707070",
      strokeWidth: "1.58px",
      strokeLinecap: "round"
    },
    points: "81.974 12.135 81.974 0.535 104.31 0.535 104.31 18.735 96.349 18.735 96.349 24.935 81.974 24.935 81.974 20.635",
    id: "polyline1",
    transform: "matrix(1.0876374,0,0,0.99731294,-9.1742368,0.03421976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.52917,0.57052 v 24.384 l 17.904,-0.03036 v -6.1923 l 6.4958,-0.01102 -0.01613,-18.192 z",
    fill: "#f9f9f9",
    stroke: "#707070",
    strokeWidth: 1.5875,
    id: "path1",
    style: {
      display: "inline"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5875,
    transform: "rotate(90,95.50038,19.15927)",
    id: "g4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 82.162149,2.6336201 20.205701,-0.043471 -0.0219,2.4798069 H 82.13261 v 2.6368943 l 10.460654,-0.01405",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.6335,
    id: "path4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 94.807097,7.5744982 7.537863,0.010403 V 10.165563 H 82.134015 v 2.596476 H 95.11708",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.63206,
    id: "path4-6",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#4894ff",
      strokeOpacity: 0.54383767
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.65758301,-0.65758301,0,108.75748,-54.606292)",
    id: "g3"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#000000",
      strokeWidth: 1
    },
    cx: 92.673218,
    cy: 20.355787,
    id: "ellipse1",
    r: 1.274
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#000000",
      strokeWidth: 1
    },
    cx: 97.203003,
    cy: 20.368999,
    id: "ellipse2",
    r: 1.274
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#027cbd",
      stroke: "#027cbd",
      strokeWidth: 1
    },
    cx: 94.760002,
    cy: 22.962,
    id: "ellipse3",
    r: 2.4690001
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#707070",
      fillOpacity: 1,
      stroke: "#707070",
      strokeWidth: 0.248924,
      strokeOpacity: 1
    },
    id: "rect5",
    width: 1.4677085,
    height: 10.742648,
    x: 79.244217,
    y: 10.546594,
    ry: 0.79858655
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatPathDemoNavigatorIcon);
export default __webpack_public_path__ + "static/media/RepeatPathDemoNavigatorIcon.67f6f79998e3642842649480b852977f.svg";
export { ForwardRef as ReactComponent };